import axios from "axios";

export const getList = async (category, orderBy, whereClause) => {
  const response = await axios.get(`/api/getList/${category}?orderby=${orderBy}&where=${whereClause || ''}`);
  return response.data;
};
